export default "__VITE_ASSET__CpMgu0EC__"